import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialPostsDesignActionModalProps} from '@Modals/social-post-design-action-modal/social-post-design-action-modal.types';

export const openDesignActionModal = (props: SocialPostsDesignActionModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_POST_DESIGN_ACTION_MODAL,
      panelProps: props,
    })
  );
};
